import React from 'react'
import { Animated, Modal, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useSelector } from 'react-redux';
import FlashMessageComp from '../../flashMessage/flashMessage';
import CustomPressable from '../../customPressable/customPressable';
import SlideTransition from '../../slideTransition';
import { PanGestureHandler, State } from 'react-native-gesture-handler';

const CustomModal_Landscape = ({ onRequestClose, children, customInnerCompsStyleWeb={}, landscapeStyle={}, slideFromRight }) => {
    const getStyles = useCssStyle();
    const SWIPE_THRESHOLD = 150;
    const translateY = new Animated.Value(0);
    const translateX = new Animated.Value(0);

    const { renderFlashMessage } = useSelector(state => state.appConfigSlice);


    console.log("slideFromRight", slideFromRight);
    
    const onGestureEvent = slideFromRight
        ? Animated.event(
            [{ nativeEvent: { translationX: translateX } }],
            {
                useNativeDriver: false,
                listener: ({ nativeEvent }) => {
                    if (nativeEvent.translationX < 0) translateX.setValue(0);
                },
            }
        )
        : Animated.event(
            [{ nativeEvent: { translationY: translateY } }],
            {
                useNativeDriver: false,
                listener: ({ nativeEvent }) => {
                    if (nativeEvent.translationY < 0) translateY.setValue(0);
                },
            }
        );

    const onHandlerStateChange = ({ nativeEvent }) => {
        if (nativeEvent.state === State.END) {
            const translation = slideFromRight ? nativeEvent.translationX : nativeEvent.translationY;
            const animValue = slideFromRight ? translateX : translateY;

            if (translation > SWIPE_THRESHOLD && onRequestClose) {
                onRequestClose();
            } else {
                Animated.spring(animValue, {
                    toValue: 0,
                    useNativeDriver: false,
                }).start();
            }
        }
    };

    return (
        <Modal visible={true} transparent statusBarTranslucent animationType="fade" onRequestClose={onRequestClose}>
            <View style={{ flex: 1 }}>

                {/* FlashMessage for modal - renders on top */}
                {renderFlashMessage.isVisible && <FlashMessageComp messageConfig={renderFlashMessage.messageConfig} />}

                {/* Backdrop with fade animation */}
                <CustomPressable
                    onPress={onRequestClose}
                    style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)" }}
                />

                {/* Modal container positioned at bottom */}
                <View
                    style={getStyles(['customModalInnerContainer_landscape', {...customInnerCompsStyleWeb}, {...landscapeStyle}])}
                    pointerEvents="box-none"
                    id='customModalInnerContainer_landscape'
                >
                    {/* Modal Content with slide-up animation and swipe-down gesture */}
                    <SlideTransition duration={200} from={350} axis={slideFromRight ? "x" : "y"} style={{...customInnerCompsStyleWeb, ...landscapeStyle}}>
                        {onRequestClose ? (
                            <PanGestureHandler
                                onGestureEvent={onGestureEvent}
                                onHandlerStateChange={onHandlerStateChange}
                                activeOffsetY={slideFromRight ? [-20, 20] : [-5, 5]}
                                activeOffsetX={slideFromRight ? [-5, 5] : [-20, 20]}
                                failOffsetX={slideFromRight ? undefined : [-20, 20]}
                                failOffsetY={slideFromRight ? [-20, 20] : undefined}
                            >
                                <Animated.View
                                    style={{
                                        ...customInnerCompsStyleWeb,
                                        ...landscapeStyle,
                                        transform: slideFromRight
                                            ? [{ translateX }]
                                            : [{ translateY }],
                                    }}
                                >
                                    {children}
                                </Animated.View>
                            </PanGestureHandler>
                        ) : (
                            <View>
                                {children}
                            </View>
                        )}
                    </SlideTransition>
                </View>
            </View>
        </Modal>
    )
}

export default CustomModal_Landscape
